import "@djthoms/pretty-checkbox";
import { Checkbox } from "pretty-checkbox-react";
import React from "react";
import { DashboardUtils, RevertDescriptor } from "../dashboard_utils";
import { EventCreationInputKeys, PremiumFeatures } from "../event_creation";
import { GuildSettingsFormStateKeys } from "../guild_settings/guild_settings";
import { PollCreationInputKeys } from "../poll_creation";

interface AccordianProp<T> {
	opened_initially: boolean;
	label: string;
	render_child: (field_key: any, initial_value: T) => JSX.Element;
	initial_value: T;
	field_key:
		| EventCreationInputKeys
		| PollCreationInputKeys
		| GuildSettingsFormStateKeys;
	is_server_premium: boolean;
	is_beta?: boolean;
	info?: string | JSX.Element;
	note?: string;
	updateFunc?: Function;
	disabled?: boolean;
	unsaved_changes?: boolean;
	onCheckboxUnclicked?: Function;
	loading?: boolean;
	disabled_element_func?: Function;
	is_overridden?: boolean;
	should_hide_checkbox?: boolean;
	is_new?: boolean;
	show_always?: boolean;

	revert_descriptor?: RevertDescriptor<any>;
}

interface AccordianState {
	opened: boolean;
	locked: boolean;
}

export default class SeshAccordian<T> extends React.Component<
	AccordianProp<T>,
	AccordianState
> {
	constructor(props) {
		super(props);
		let locked =
			!this.props.is_server_premium &&
			PremiumFeatures.includes(this.props.field_key);
		let opened = this.props.opened_initially;
		if (locked) {
			opened = false;
		}
		this.state = {
			opened: opened,
			locked: locked,
		};
	}

	handleClick(event) {
		if (this.state.locked) {
			return;
		}
		let opened: boolean = event.target.checked;
		this.setState({ opened: opened });

		if (!opened && this.props.onCheckboxUnclicked) {
			this.props.onCheckboxUnclicked();
		}

		if (this.props.updateFunc) {
			this.props.updateFunc(this.props.field_key, opened);
		}
	}

	renderChild() {
		if (this.props.loading) {
			return DashboardUtils.RenderLoadingThrobber(null, 1);
		}

		if (this.state.opened) {
			return this.props.render_child(
				this.props.field_key,
				this.props.initial_value
			);
		}
	}

	renderUnopenedChild() {
		if (this.props.loading) {
			return DashboardUtils.RenderLoadingThrobber(null, 1);
		}
		if (!this.state.opened) {
			return this.props.disabled_element_func(
				this.props.field_key,
				this.props.initial_value
			);
		}
	}

	render() {
		let outerClassName = "field";

		const checkbox = (
			<span
				className={`checkbox-wrapper${
					this.props.should_hide_checkbox ? ` is-invisible` : ""
				}`}
			>
				<Checkbox
					key={this.props.label + this.state.opened}
					className="title-checkbox"
					name="has_reminders"
					checked={this.state.opened}
					onChange={(e) => this.handleClick(e)}
					disabled={this.props.disabled}
				/>
			</span>
		);

		if (this.state.opened) {
			outerClassName += ` expanded-collapsible`;
		}

		if (this.props.is_overridden) {
			outerClassName += ` overridden-field`;
		}

		return (
			<div id={this.props.field_key} className={outerClassName}>
				<div>
					{DashboardUtils.CreateHeaderAndInfoButton(
						this.props.label,
						this.props.info,
						this.state.locked,
						this.props.is_beta,
						this.props.unsaved_changes,
						checkbox,
						this.props.disabled,
						this.props.is_new,
						!this.state.locked
							? this.props.revert_descriptor
							: undefined
					)}
					{this.props.note && (
						<div className="note">{this.props.note}</div>
					)}
					{this.props.render_child && this.state.opened && (
						<div>{this.renderChild()}</div>
					)}
					{this.props.disabled_element_func && !this.state.opened && (
						<div>{this.renderUnopenedChild()}</div>
					)}
				</div>
			</div>
		);
	}
}
